(function (root) {
  'use strict';
  const normalized = value => String(value || '').toLowerCase().trim();
  function pricingUnit(data) {
    const explicit = normalized(data.pricingUnit);
    if (['per_person', 'per_cabin', 'per_charter'].includes(explicit)) return explicit;
    const occupancy = normalized(data.occupancy);
    const basis = normalized(data.rateBasis);
    // Occupancy is structured data; free-text notes may mention other cabin rates.
    if (/per\s+(person|guest|diver|pax|berth)\b/.test(occupancy)) return 'per_person';
    if (/full\s+charter|per\s+charter/.test(occupancy)) return 'per_charter';
    if (/per\s+cabin|private occupancy/.test(occupancy)) return 'per_cabin';
    if (/per\s+(person|guest|diver|pax|berth)\b/.test(basis)) return 'per_person';
    if (/per\s+(cabin|room|unit)\b/.test(basis)) return 'per_cabin';
    if (/per\s+charter/.test(basis)) return 'per_charter';
    if (/twin|double|single|triple|quad/.test(occupancy)) return 'per_person';
    return null;
  }
  function linePrice(data, units, guests) {
    const rate = Number(data.rate);
    const unit = pricingUnit(data);
    if (!unit || !Number.isFinite(rate) || rate <= 0 || !Number.isInteger(units) || !Number.isInteger(guests) || units < 1 || guests < 1) return null;
    if (unit === 'per_charter' && units !== 1) return null;
    return Math.round((rate * (unit === 'per_person' ? guests : units) + Number.EPSILON) * 100) / 100;
  }
  function calendarNights(start, end) {
    const parse = value => /^\d{4}-\d{2}-\d{2}$/.test(String(value)) ? Date.parse(value + 'T00:00:00Z') : NaN;
    const nights = (parse(end) - parse(start)) / 86400000;
    return Number.isInteger(nights) && nights > 0 ? nights : null;
  }
  const api = { pricingUnit, linePrice, calendarNights };
  root.CTLiveaboardPricing = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
